import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { useSession } from 'next-auth/react';

const UsageContext = createContext();

export function useUsage() {
  return useContext(UsageContext);
}

export const UsageProvider = ({ children }) => {
  const [usageData, setUsageData] = useState(null);
  const { data: session, status } = useSession();  // Destructure the session and status from useSession

  const fetchUsageData = useCallback(async () => {
    // Check if user is authenticated
    if (status !== "authenticated") {
      return;
    }

    try {
      const res = await fetch('/api/usage');
      if (!res.ok) {
        throw new Error(`Failed to fetch, status code: ${res.status}`);
      }
      const data = await res.json();
      setUsageData(data);
    } catch (error) {
      console.error("Failed to fetch usage data", error);
    }
  }, [status]); // Include 'status' in the dependency array to re-run the effect when it changes

  useEffect(() => {
    fetchUsageData();
  }, [fetchUsageData]);

  const value = {
    usageData,
    refreshUsageData: fetchUsageData,
  };

  return (
    <UsageContext.Provider value={value}>
      {children}
    </UsageContext.Provider>
  );
};
